module.exports = __webpack_public_path__ + "static/media/insured-passengers.69afa681.svg";